import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {NumberTextBoxComponent} from "@irb-common/components/number-text-box/number-text-box.component";

@Component({ standalone: false,
    selector: 'irb-household-location-preferences',
    templateUrl: './household-location-preferences.component.html',
    styleUrls: ['./household-location-preferences.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HouseholdLocationPreferencesComponent implements OnInit {
    textRothLevelValue: any;
    sliderRothLevelValue: any;
    initialRothLevelValue: any;
    rothLevelValuePlaceholder: any;

    textLevelValue: any;
    sliderLevelValue: any;
    initialLevelValue: any;
    levelValuePlaceholder: any;
    textLevelValuePrev:any;
    textRothLevelValuePrev:any;

    private _householdLocationPreferencesData: any;
    arr = Array;
    levelSliderNumber = 10;
    rothLevelSliderNumber = 10;
    levelMinValue = -100;
    levelMaxValue = 100;
    rothLevelMinValue = 0;
    rothLevelMaxValue = 100;
    private _isDataLoaded = false;
    @ViewChild('textLevelValueInput') textLevelValueInput: NumberTextBoxComponent;
    @ViewChild('textRothLevelValueInput') textRothLevelValueInput: NumberTextBoxComponent;

    @Input()
    set householdLocationPreferencesData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._isDataLoaded = false;
        this._householdLocationPreferencesData = value;
        this.getInitialSliderValues();
        this._isDataLoaded = true;
    }

    @Output()
    rothLevelChanged: EventEmitter<Number> = new EventEmitter<Number>();

    @Output()
    levelChanged: EventEmitter<Number> = new EventEmitter<Number>();

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() { this.cdr.detectChanges(); }

    handleTextLevelChange() {
        if(this._isDataLoaded && this.textLevelValue !== this.textLevelValuePrev) {
            this.sliderLevelValue = this.textLevelValue;
            this.levelChanged.emit(parseInt(this.textLevelValue)); // this emit handles both slider and text changes
        }
    }

    handleSliderLevelChange() {
        this.textLevelValue = this.sliderLevelValue;
        if(this.textLevelValueInput && this.textLevelValueInput.inputControl) {
            this.textLevelValueInput.inputControl.setValue(this.textLevelValue);
            this.textLevelValueInput.onChange();
        }
    }

    handleTextRothLevelChange() {
        if(this._isDataLoaded && this.textRothLevelValue !== this.textRothLevelValuePrev) {
            this.sliderRothLevelValue = this.textRothLevelValue;
            this.rothLevelChanged.emit(parseInt(this.textRothLevelValue));
        }
    }

    handleSliderRothLevelChange() {
        this.textRothLevelValue = this.sliderRothLevelValue;
        if(this.textRothLevelValueInput && this.textRothLevelValueInput.inputControl) {
            this.textRothLevelValueInput.inputControl.setValue(this.textRothLevelValue);
            this.textRothLevelValueInput.onChange();
        }
    }

    private getInitialSliderValues() {
        if (this._householdLocationPreferencesData.multipleSecurity) {
           this.loadMultipleSecurity();
        } else {
            this.loadSingleSecurity();
        }
    }

    private loadSingleSecurity() {
        this.levelValuePlaceholder = "";
        this.rothLevelValuePlaceholder = "";
        if (this._householdLocationPreferencesData && this._householdLocationPreferencesData.securityData) {
            this.textLevelValue = this.sliderLevelValue = this._householdLocationPreferencesData.securityData[0].taxabilityBias || 0;
            this.textRothLevelValue = this.sliderRothLevelValue = this._householdLocationPreferencesData.securityData[0].rothLevel || 0;
            this.textLevelValuePrev = this.textLevelValue;
            this.textRothLevelValuePrev = this.textRothLevelValue;
        }
    }

    private loadMultipleSecurity() {
        if (this._householdLocationPreferencesData && this._householdLocationPreferencesData.securityData
            && this._householdLocationPreferencesData.securityData.length > 0) {

            this.initialLevelValue = this.getInitialValue("taxabilityBias", this._householdLocationPreferencesData.securityData);
            this.textLevelValue = this.sliderLevelValue = this.initialLevelValue === 'Various' ? null : this.initialLevelValue || 0;
            this.levelValuePlaceholder = this.initialLevelValue === 'Various' ? this.initialLevelValue : "";

            this.initialRothLevelValue = this.getInitialValue("rothLevel", this._householdLocationPreferencesData.securityData);
            this.textRothLevelValue = this.sliderRothLevelValue = this.initialRothLevelValue === 'Various' ? null : this.initialRothLevelValue || 0;
            this.rothLevelValuePlaceholder = this.initialRothLevelValue === 'Various' ? this.initialRothLevelValue : "";

            this.textLevelValuePrev = this.textLevelValue;
            this.textRothLevelValuePrev = this.textRothLevelValue;
        }
    }

    private getInitialValue(name: string, items: any[]) {
        let inputVal = items[0][name];
        for (let i = 0; i < items.length; i++) {
            let thisVal = items[i][name];
            if (inputVal != thisVal) {
                inputVal = "Various";
            }
        }
        return inputVal;
    }

    isValid() {
        let isValid: boolean = true;
        if(this.textLevelValue || (this.textLevelValueInput && this.textLevelValueInput.inputControl
                            && this.textLevelValueInput.inputControl.touched)) {
            const numericLevelValue = parseInt(this.textLevelValue);
            isValid = isValid && this.isValidLevelValue(numericLevelValue);
        }
        if(this.textRothLevelValue || (this.textRothLevelValueInput && this.textRothLevelValueInput.inputControl
            && this.textRothLevelValueInput.inputControl.touched)) {
            const numericRothLevelValue = parseInt(this.textRothLevelValue);
            isValid = isValid && this.isValidRothLevelValue(numericRothLevelValue);
        }

        return isValid;
    }
    public isValidLevelValue(level: any) {
        let levelRegex = new RegExp("^(-)?[0-9]+(\.[0-9]{0,0})?$");
        const validFormat = level.toString().match(levelRegex) != null;
        return (level >= this.levelMinValue && level <= this.levelMaxValue) && validFormat;
    }
    public isValidRothLevelValue(rothLevel: any) {
        const regExp = new RegExp("^[0-9]+(\.[0-9]{0,0})?$");
        const validFormat = rothLevel.toString().match(regExp) != null;
        return (rothLevel >= this.rothLevelMinValue && rothLevel <= this.rothLevelMaxValue) && validFormat;
    }
}
